import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { useExternalIntegrations } from 'components/ExportModal/ExternalIntegrations/ExternalIntegrations'

export const useEmailIntegrations = () => {
  const { data } = useExternalIntegrations()
  const integrations = data?.external_integrations

  if (!integrations) {
    return {
      connectedEmailIntegration: null,
    }
  }

  const connectedEmailIntegration =
    integrations.find((integration) => integration.provider === ExternalIntegrationEnum.Mailchimp) ?? null

  return {
    connectedEmailIntegration,
  }
}
